// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ddOH","toggleWrap":"styles_toggleWrap__2tv8x","content":"styles_content__1Qj3r","selectAreaCode":"styles_selectAreaCode__3SMG8"};